import {
  AppWindow,
  Layers,
  Cpu,
  Database,
  HardDrive,
  Upload,
  Download,
  ShieldCheck,
  ShieldAlert,
  HeartPulse,
  Activity,
  Monitor,
  Terminal,
  Settings,
  Wrench,
  File,
  FileDown,
  FileUp,
  FileLock,
  Folder,
  FolderClosed,
  FolderOpen,
  Save,
  Rocket,
  CircuitBoard,
  Network,
  Link,
  Plug,
  Power,
  TriangleAlert,
  Bug,
  Apple,
  Clipboard,
  Timer,
  Lock,
  Key,
  Recycle,
  RotateCcw,
  Eye,
  Flame,
  Flag,
  Globe,
  Hand,
  MapPin,
  Moon,
  Paperclip,
  Pen,
  Phone,
  Shield,
  Sun,
  Trophy,
  User,
  Cloud,
  RadioTower,
  CircleAlert,
  Laptop,
  ClipboardList,
  Cctv,
  Barcode,
  Box,
  Smartphone,
  Gamepad2,
  BarChart3,
  Bot,
  Store,
  Users,
  Video,
  Plus,
  BoxSelect,
  Server
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

import { GeneralIcon } from '../constants/general-icons'

const GeneralIconMapping: Record<GeneralIcon, LucideIcon> = {
  [GeneralIcon.AppWindow]: AppWindow,
  [GeneralIcon.Stack]: Layers,
  [GeneralIcon.Cpu]: Cpu,
  [GeneralIcon.Database]: Database,
  [GeneralIcon.HardDrive]: HardDrive,
  [GeneralIcon.Upload]: Upload,
  [GeneralIcon.Download]: Download,
  [GeneralIcon.ShieldCheck]: ShieldCheck,
  [GeneralIcon.ShieldWarning]: ShieldAlert,
  [GeneralIcon.Heartbeat]: HeartPulse,
  [GeneralIcon.Activity]: Activity,
  [GeneralIcon.Monitor]: Monitor,
  [GeneralIcon.Terminal]: Terminal,
  [GeneralIcon.Gear]: Settings,
  [GeneralIcon.Wrench]: Wrench,
  [GeneralIcon.File]: File,
  [GeneralIcon.FileArrowDown]: FileDown,
  [GeneralIcon.FileArrowUp]: FileUp,
  [GeneralIcon.FileLock]: FileLock,
  [GeneralIcon.Folder]: Folder,
  [GeneralIcon.FolderNotch]: FolderClosed,
  [GeneralIcon.FolderOpen]: FolderOpen,
  [GeneralIcon.FloppyDisk]: Save,
  [GeneralIcon.Rocket]: Rocket,
  [GeneralIcon.Circuitry]: CircuitBoard,
  [GeneralIcon.Network]: Network,
  [GeneralIcon.Link]: Link,
  [GeneralIcon.Plug]: Plug,
  [GeneralIcon.Power]: Power,
  [GeneralIcon.Warning]: TriangleAlert,
  [GeneralIcon.Bug]: Bug,
  // Lucide doesn't ship brand logos — fall back to closest generic shapes.
  [GeneralIcon.WindowsLogo]: AppWindow,
  [GeneralIcon.AppleLogo]: Apple,
  [GeneralIcon.LinuxLogo]: Server,
  [GeneralIcon.Clipboard]: Clipboard,
  [GeneralIcon.Timer]: Timer,
  [GeneralIcon.Lock]: Lock,
  [GeneralIcon.Key]: Key,
  [GeneralIcon.Recycle]: Recycle,
  [GeneralIcon.ArrowsCounterClockwise]: RotateCcw,
  [GeneralIcon.Eye]: Eye,
  [GeneralIcon.Fire]: Flame,
  [GeneralIcon.Flag]: Flag,
  [GeneralIcon.Globe]: Globe,
  [GeneralIcon.Hand]: Hand,
  [GeneralIcon.MapPin]: MapPin,
  [GeneralIcon.Moon]: Moon,
  [GeneralIcon.Paperclip]: Paperclip,
  [GeneralIcon.Pen]: Pen,
  [GeneralIcon.Phone]: Phone,
  [GeneralIcon.Shield]: Shield,
  [GeneralIcon.Sun]: Sun,
  [GeneralIcon.Trophy]: Trophy,
  [GeneralIcon.User]: User,
  [GeneralIcon.Cloud]: Cloud,
  [GeneralIcon.DownloadSimple]: Download,
  [GeneralIcon.AirTrafficControl]: RadioTower,
  [GeneralIcon.WarningCircle]: CircleAlert,
  [GeneralIcon.Laptop]: Laptop,
  [GeneralIcon.ClipboardText]: ClipboardList,
  [GeneralIcon.SecurityCamera]: Cctv,
  [GeneralIcon.Barcode]: Barcode,
  [GeneralIcon.Cube]: Box,
  [GeneralIcon.Browser]: AppWindow,
  [GeneralIcon.Desktop]: Monitor,
  [GeneralIcon.DeviceMobile]: Smartphone,
  [GeneralIcon.GameController]: Gamepad2,
  [GeneralIcon.ChartBar]: BarChart3,
  [GeneralIcon.Robot]: Bot,
  [GeneralIcon.Storefront]: Store,
  [GeneralIcon.UsersThree]: Users,
  [GeneralIcon.VideoCamera]: Video,
  [GeneralIcon.Plus]: Plus,
  [GeneralIcon.SelectionAll]: BoxSelect
}

export default GeneralIconMapping
